// Wave 97 — turnaround strings ("1 วันทำการ", "3-5 วันทำการ") live in Thai
// source data. Localize them at render time so non-Thai pages stay locale-pure.

const UNIT: Record<string, string> = {
  th: "วันทำการ",
  en: "business days",
  zh: "个工作日",
  ja: "営業日",
  ko: "영업일",
  ru: "раб. дн.",
  ar: "أيام عمل",
  de: "Werktage",
  fr: "jours ouvrés",
  es: "días hábiles",
  pt: "dias úteis",
  vi: "ngày làm việc",
  id: "hari kerja",
};

const SAME_DAY: Record<string, string> = {
  th: "ภายในวันเดียว",
  en: "same day",
  zh: "当天",
  ja: "当日",
  ko: "당일",
  ru: "в тот же день",
  ar: "في نفس اليوم",
  de: "am selben Tag",
  fr: "le jour même",
  es: "el mismo día",
  pt: "no mesmo dia",
  vi: "trong ngày",
  id: "hari yang sama",
};

/** "3-5 วันทำการ" → "3-5 business days" (or the locale equivalent). */
export function localizeTurnaround(value: string, locale: string): string {
  if (!value) return value;
  if (locale === "th") return value;
  const unit = UNIT[locale] ?? UNIT.en;
  let out = value.replace(/ภายในวันเดียว|วันเดียวกัน/g, SAME_DAY[locale] ?? SAME_DAY.en);
  out = out.replace(/วันทำการ/g, unit).replace(/\s*วัน(?![\u0E00-\u0E7F])/g, ` ${unit}`);
  return out.replace(/\s{2,}/g, " ").trim();
}
